"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileExtension = exports.getFileExtFromMime = exports.SUPPORTED_TYPES_WITH_HEIC = exports.SUPPORTED_TYPES = exports.SUPPORTED_MIME_TYPES_WITH_HEIC = exports.SUPPORTED_MIME_TYPES = void 0;

const getFileExtFromMime = (mime = "") => {
  const idx = mime.lastIndexOf("/");
  if (idx === -1) return null;
  return mime.substr(idx + 1);
};

exports.getFileExtFromMime = getFileExtFromMime;

const getFileExtension = (str = "") => {
  return str.indexOf(".") === -1 ? "" : (str.split(".").pop() || "").toLowerCase();
};

exports.getFileExtension = getFileExtension;
const SUPPORTED_TYPES = [".mp4", ".jpg", ".jpeg", ".png"];
exports.SUPPORTED_TYPES = SUPPORTED_TYPES;
const SUPPORTED_TYPES_WITH_HEIC = [".mp4", ".jpg", ".jpeg", ".png", ".heic"];
exports.SUPPORTED_TYPES_WITH_HEIC = SUPPORTED_TYPES_WITH_HEIC;
const SUPPORTED_MIME_TYPES = "image/jpeg, image/jpg, image/png, video/mp4";
exports.SUPPORTED_MIME_TYPES = SUPPORTED_MIME_TYPES;
const SUPPORTED_MIME_TYPES_WITH_HEIC = "image/jpeg, image/jpg, image/png, video/mp4, image/heic";
exports.SUPPORTED_MIME_TYPES_WITH_HEIC = SUPPORTED_MIME_TYPES_WITH_HEIC;